import React, { useContext, useEffect, useState } from "react";

import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_SELECT,
  VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2";

import AdapterJalaali from "@date-io/jalaali";
import { CircularProgress } from "@mui/material";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";

import axios from "axios";
import jMoment from "moment-jalaali";

import { CHANGE_ORDER } from "../../redux/types";

import { useDispatch } from "react-redux";

//defining instances
const UNITS = [
  { units: "1", types: 1 },
  { units: "2", types: 1 },
  { units: "3", types: 1 },
  { units: "4", types: 1 },
  { units: "5", types: 1 },
  { units: "6", types: 1 },
  { units: "7", types: 1 },
  { units: "8", types: 2 },
  { units: "9", types: 2 },
  { units: "10", types: 2 },
  { units: "12", types: 2 },
  { units: "13", types: 2 },
  { units: "14", types: 2 },
  { units: "15", types: 3 },
  { units: "16", types: 3 },
  { units: "17", types: 3 },
  { units: "18", types: 3 },
  { units: "19", types: 3 },
  { units: "20", types: 3 },
  { units: "21", types: 3 },
  { units: "22", types: 4 },
  { units: "23", types: 4 },
  { units: "24", types: 4 },
  { units: "25", types: 4 },
  { units: "26", types: 4 },
  { units: "27", types: 4 },
  { units: "28", types: 4 },
  { units: "نامشخص", types: 5 },
  { units: "فک یالا", types: 5 },
  { units: "فک پایین", types: 5 },
];
const JAWS = ["یک فک", "دو فک"];

const EnterOrderForm = (props) => {
  const dispatch = useDispatch();
  const [addedTime, setAddedTime] = useState(0);
  const [predictionDate, setPredictionDate] = useState(
    jMoment().startOf("day")
  );
  const [startDate, setStartDate] = useState(jMoment().startOf("day"));

  const [isLoading, setIsLoading] = useState(true);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

  const [orderData, setOrderData] = useState();
  const [process, setProcess] = useState([]);
  const [counter, setCounter] = useState(0);
  const [lastProcess, setLastProcess] = useState();
  const [selectedUnit, setSelectedUnit] = useState({ units: "1", types: 1 });

  const orderId = props.orderId;

  //initilizing inputs
  const [formState, inputHandler, setFormData] = useForm(
    {
      unitCount: {
        value: "",
        isValid: false,
      },
      jawCount: {
        value: "",
        isValid: false,
      },
      upRight: {
        value: "",
        isValid: true,
      },
      upLeft: {
        value: "",
        isValid: true,
      },
      downRight: {
        value: "",
        isValid: true,
      },
      downLeft: {
        value: "",
        isValid: true,
      },
      entryDescription: {
        value: "",
        isValid: true,
      },
      tasksToDo: {
        value: [],
        isValid: false,
      },
    },
    false
  );

  //getting field values
  useEffect(() => {
    if (counter === 2) {
      setFormData(
        {
          unitCount: {
            value: selectedUnit,
            isValid: true,
          },
          jawCount: {
            value: lastProcess.jawCount,
            isValid: true,
          },
          upRight: {
            value: lastProcess.upRight,
            isValid: true,
          },
          upLeft: {
            value: lastProcess.upLeft,
            isValid: true,
          },
          downRight: {
            value: lastProcess.downRight,
            isValid: true,
          },
          downLeft: {
            value: lastProcess.downLeft,
            isValid: true,
          },
          entryDescription: {
            value: "",
            isValid: true,
          },
          tasksToDo: {
            value: [],
            isValid: false,
          },
        },
        true
      );
      setIsLoading(false);
    }
  }, [setFormData, counter]);

  const handleError = (e) => {
    const messages =
      e.response.data.data && e.response.data.data.length > 0
        ? e.response.data.data
        : e.response.data.message.message;

    Array.isArray(messages)
      ? messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        })
      : enqueueSnackbar(messages, { variant: "error" });
    setIsLoading(false);
  };
  //getting order data
  useEffect(() => {
    setIsLoading(true);
    setOrderData();
    axios
      .post(
        "/api/v1/laboratorys/get-order-process",
        {
          orderId: orderId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setOrderData(response.data.data);
        setCounter(1);
      })
      .catch((e) => {
        console.log(e);
        handleError(e);
        setCounter(1);
      });
  }, [orderId]);

  //getting order-type-processes
  useEffect(() => {
    if (counter == 1) {
      //getting last process
      orderData && setLastProcess(...orderData.process.slice(-1));

      lastProcess &&
        setSelectedUnit(
          UNITS.find(({ units }) => units === lastProcess.unitCount)
        );

      //getting order-type-processes
      setProcess([]);
      orderData.orderTypeId &&
        axios
          .post(
            "/api/v1/laboratorys/get-orderType-process",
            {
              orderTypeId: orderData.orderTypeId,
            },
            {
              headers: {
                authorization: auth.token,
              },
            }
          )
          .then((response) => {
            setProcess(response.data.data);
          })
          .catch((e) => {
            const messages =
              e.response.data.data.length > 0
                ? e.response.data.data
                : e.response.data.message.message;
            messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            });
          })
          .finally(() => setCounter(2));
    }
  }, [orderData]);

  //submit order entrance
  const EnterOrderHandler = async (event) => {
    event.preventDefault();
    let processIds = [];
    for (let i = 0; i < formState.inputs.tasksToDo.value.length; i += 1) {
      processIds.push(formState.inputs.tasksToDo.value[i].id);
    }
    setIsLoading(true);

    axios
      .post(
        "/api/v1/laboratorys/create-entry-order",
        {
          patiantName: orderData.patiantName,
          boxNumber: orderData.boxNumber,
          doctorLabId: orderData.doctorLabId,
          orderTypeId: orderData.orderTypeId,
          description: "",
          exitDescription: lastProcess.exitDescription,
          entryDescription: formState.inputs.entryDescription.value,
          orderId: orderId,
          unitCount: formState.inputs.unitCount.value.units,
          upRight: formState.inputs.upRight.value,
          upLeft: formState.inputs.upLeft.value,
          downLeft: formState.inputs.downLeft.value,
          downRight: formState.inputs.downRight.value,
          startDate: new Date(startDate).getTime(),
          predictionDate: new Date(predictionDate).getTime().toString(),
          processIds: processIds,
        },
        {
          headers: {
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        dispatch({ type: CHANGE_ORDER, payload: null });
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
      })
      .finally(() => setIsLoading(false));
  };

  //setting added time
  useEffect(() => {
    if (
      formState.inputs.jawCount.value &&
      formState.inputs.unitCount.value &&
      formState.inputs.tasksToDo.value &&
      startDate
    ) {
      switch (formState.inputs.jawCount.value) {
        case "یک فک":
          switch (formState.inputs.unitCount.value.types) {
            case 1:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].oneJaw1To7)
                );
              }
              break;
            case 2:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].oneJaw7To14)
                );
              }

              break;
            case 3:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw14To21)
                );
              }
              break;
            case 4:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw21To28)
                );
              }

              break;
            case 5:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].oneJawFull)
                );
              }
              break;
            default:
              break;
          }
          break;
        case "دو فک":
          switch (formState.inputs.unitCount.value.types) {
            case 1:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw1To7)
                );
              }
              break;
            case 2:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw7To14)
                );
              }
              break;
            case 3:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw14To21)
                );
              }
              break;
            case 4:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJaw21To28)
                );
              }
              break;
            case 5:
              setAddedTime(0);
              for (
                let i = 0;
                i < formState.inputs.tasksToDo.value.length;
                i += 1
              ) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasksToDo.value[i].twoJawFull)
                );
              }
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    }
  }, [
    formState.inputs.jawCount.value,
    formState.inputs.unitCount.value,
    formState.inputs.tasksToDo.value,
    startDate,
  ]);

  //set prediction date
  useEffect(() => {
    // i had to convert it to dateTime object because the component accepts DateTime
    addedTime &&
      setPredictionDate(new Date(Number(startDate) + addedTime * 86400000));
  }, [
    addedTime,
    formState.inputs.jawCount.value,
    formState.inputs.unitCount.value,
    formState.inputs.tasksToDo.value,
    startDate,
  ]);

  return (
    <>
      {isLoading ? (
        <CircularProgress color="primary" />
      ) : (
        <form onSubmit={EnterOrderHandler}>
          <Grid container spacing={2} alignItems={"center"}>
            <Grid md={4} xs={12}>
              {!orderData ? (
                <Chip
                  label="لطفا یک سفارش را انتخاب کنید."
                  color="error"
                  sx={{ p: 2 }}
                />
              ) : (
                <Chip
                  label={`___${orderData.boxNumber}___`}
                  color="success"
                  sx={{ p: 2 }}
                />
              )}
            </Grid>
            <Grid md={8} xs={12}>
              <Input
                id="tasksToDo"
                element="select"
                validators={[VALIDATOR_SELECT()]}
                errorText="لطفا عملیات را انتخاب کنید."
                multiline={true}
                onInput={inputHandler}
                initialValue={formState.inputs.tasksToDo.value}
                options={process}
                inputValid={formState.inputs.tasksToDo.isValid}
                label="جهت انجام"
              />
            </Grid>
            <Grid md={12}>
              <hr />
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterJalaali}>
                  <DatePicker
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    // disableFuture={true}
                    label="تاریخ ورود"
                    disableMaskedInput
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size={"medium"}
                        variant={"outlined"}
                      />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>{" "}
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="unitCount"
                element="autoComplete"
                label="تعداد واحد"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا تعداد واحد را انتخاب کنید."
                onInput={inputHandler}
                options={UNITS}
                getOptionLabel={(unit) => unit.units}
                required={true}
                initialValue={formState.inputs.unitCount.value}
                inputValid={formState.inputs.unitCount.isValid}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="jawCount"
                element="autoComplete"
                label="تعداد فک"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا تعداد فک را انتخاب کنید."
                onInput={inputHandler}
                getOptionLabel={(jaw) => jaw}
                options={JAWS}
                required={true}
                inputValid={formState.inputs.jawCount.isValid}
                initialValue={formState.inputs.jawCount.value}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="upRight"
                element="number_only"
                label="شماره دندان (فک بالا راست)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.upRight.value}
                inputValid={formState.inputs.upRight.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="upLeft"
                element="number_only"
                label="شماره دندان (فک بالا چپ)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.upLeft.value}
                inputValid={formState.inputs.upLeft.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="downRight"
                element="number_only"
                label="شماره دندان (فک پایین راست)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.downRight.value}
                inputValid={formState.inputs.downRight.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="downLeft"
                element="number_only"
                label="شماره دندان (فک پایین چپ)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.downLeft.value}
                inputValid={formState.inputs.downLeft.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={12} xs={12}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterJalaali}>
                  <DatePicker
                    value={predictionDate}
                    onChange={(date) => setPredictionDate(date)}
                    disablePast={true}
                    label="پیش بینی خروج"
                    disableMaskedInput
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size={"medium"}
                        variant={"outlined"}
                      />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid md={12} xs={12}>
              <Input
                id="entryDescription"
                element="input"
                label="توضیحات جهت ارسال"
                validators={[VALIDATOR_VALIDATED()]}
                multiline={true}
                onInput={inputHandler}
                inputValid={true}
                initialValue={formState.inputs.entryDescription.value}
              />
            </Grid>
            <Grid xs={12} sm={12}>
              <Button
                type="submit"
                disabled={!formState.isValid || orderId === ""}
                fullWidth
                color="secondary"
                variant="contained"
              >
                ثبت دریافت
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

export default EnterOrderForm;
